import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Places } from './places';
import { Options } from './options';
import { Prices } from './prices';
import { Promotions } from './promotions';

export const FlightsType = new Mongo.Collection('flights_type');
export const FlightType = new SimpleSchema({
    title: {
        type: String,
        label: "Titre"
    },
    description: {
        type: String,
        label: "Description",
        optional: true
    },
    remboursement: {
        type: String,
        label: "Remboursement",
        optional: true
    },
    color: {
        type: String,
        label: "Couleur",
        optional: true
    },
    constraintPlace: {
        type: String,
        label: "Contrainte de lieu",
        optional: true
    },
    constraintPeriod: {
        type: String,
        label: "Contrainte de periode",
        optional: true
    },
    constraintPassengerMin: {
        type: Number,
        label: "Nombre de passagers minimum",
        autoValue: function(value) {
            if(!value)
                return 0;
        }
    },
    constraintPassengerMax: {
        type: Number,
        label: "Nombre de passagers maximum",
        autoValue: function(value) {
            if(!value)
                return 7;
        }
    },
    priceIds: {
        type: [Prices],
        label: "Tarifs possibles",
        optional: true
    },
    priceSemaine: {
    	type: Number,
    	label: "Prix SEMAINE",
    	optional: true
    },
    priceLibreDate: {
    	type: Number,
    	label: "Prix LIBRE DATE",
    	optional: true
    },
    priceEnfant: {
    	type: Number,
    	label: "Prix ENFANT",
    	optional: true
    },
    optionIds: {
        type: [Options],
        label: "Options possibles"
    },
    promotionIds: {
        type: [Promotions],
        label: "Promotions possibles"
    },
    reference: {
        type: String,
        label: "Référence sur le site internet",
        optional: true
    },
    infoBillet: {
        type: String,
        label: "Info sur le billet",
        optional: true
    },
    partnerId: {
    	type: String,
    	label: "Vol partenaire",
    	optional: true
    },
    quantity: {
    	type: Number,
    	label: "Nombre maximum d'utilisation",
    	optional: true
    },
    deleted: {
    	type: Boolean,
    	label: "Supprimé",
    	defaultValue: false
    },
    createdAt: {
        type: Date,
        label: "Date de création"
    }
  });

FlightsType.attachSchema(FlightType);

// Dbs methods :

Meteor.methods({
	'flightsType.remove'(_id) {
		FlightsType.update(_id, { "$set": {deleted: true} });
	},
	'flightsType.update'({_id, attributes}) {
		FlightsType.update(_id, { "$set": attributes });
	},
	'flightsType.insert'({attributes}) {
		FlightsType.insert(attributes);
	},
	'flightsType.insertPartner'({attributes}) {
		delete(attributes._id);
		FlightsType.insert(attributes);

		console.log('attributes', attributes);
	}
});

FlightsType.helpers({
    prices() {
        return Prices.find({_id: {$in: this.priceIds}}).fetch();
    },
    options() {
        return Options.find({_id: {$in:this.optionIds}}).fetch();
    },
    promotions() {
        return Promotions.find({_id: {$in: this.promotionIds}}).fetch();
    },
    periodes() {
        if(this.constraintPeriod == 'Aucune restriction') {
            return [
                    {
                        _id: 'aucune',
                        name: 'Tous les jours'
                    },
                    {
                    	_id: "Semaine uniquement",
                    	name: "Semaine uniquement"
                	}
                ];
        }
        else {
            return [
                {
                    _id: "Semaine uniquement",
                    name: "Semaine uniquement"
                }
            ];
        }
    },
    places() {

    	return [
                {
                    _id: "anjou",
                    name: "Sites d'envol Anjou"
                },
                {
                    _id: "nantes",
                    name: "Sites d'envol de Nantes"
                }
            ];

        if(this.constraintPlace == 'aucune') {
            return [
                {
                    _id: "anjou",
                    name: "Sites d'envol Anjou"
                },
                {
                    _id: "nantes",
                    name: "Sites d'envol de Nantes"
                }
            ];
        }
        if(this.constraintPlace == 'anjou') {
            return [
                {
                    _id: "anjou",
                    name: "Sites d'envol Anjou"
                }
            ];
        }
        if(this.constraintPlace == 'nantes') {
            return [
                    {
                        _id: "nantes",
                        name: "Sites d'envol de Nantes"
                    }
                ];
        }
    }
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/flights-type/flights-type.js
 **/